import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import { useChangeTracker } from '../../context/change-tracker';
import * as Styled from './styles';
import * as SX from './sx';
import type { FooterNavigationProps as Props } from './types';

export const FooterNavigation = memo(({ className }: Props) => {
  const { isDirty, resetDirty } = useChangeTracker();

  const handleSave = () => {
    resetDirty();
  };

  const handleCancel = () => {};

  return (
    <Styled.Wrapper
      className={classnames('FooterNavigation', className)}
      sx={SX.root}
      direction="row"
      gap={1}
      justifyContent="flex-end"
    >
      <Button
        variant="outlined"
        color="default"
        size="small"
        onClick={handleCancel}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="small"
        disabled={!isDirty}
        onClick={handleSave}
      >
        Save Changes
      </Button>
    </Styled.Wrapper>
  );
});

FooterNavigation.displayName = 'FooterNavigation';
